var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, all } from 'redux-saga/effects';
import { downloadFile } from '../../../utils';
import { getParsedError } from '../../form-manager-module/sagas/_utils/get-parsed-error';
export function downloadFilesManagerWorkerSaga(_a) {
    var _b, setModalAction, errorLoggerGlobal, _c, error, errorText, data, additionalErrors, formattedData_1, error_1, errorData_1, customModalTitle, params, logger;
    var _d;
    var downloadFileRequest = _a.downloadFileRequest, requestParams = _a.requestParams, loadingStartAction = _a.loadingStartAction, loadingStopAction = _a.loadingStopAction, setErrorAction = _a.setErrorAction, setErrorActionsArray = _a.setErrorActionsArray, formSuccessAction = _a.formSuccessAction, formSuccessActionsArray = _a.formSuccessActionsArray, showNotificationError = _a.showNotificationError, showNotificationSuccess = _a.showNotificationSuccess, notificationSuccessMessage = _a.notificationSuccessMessage, fileType = _a.fileType, responseDataFormatter = _a.responseDataFormatter, store = _a.store, callBackOnSuccess = _a.callBackOnSuccess, callBackOnError = _a.callBackOnError, dispatch = _a.dispatch, titleMessageError = _a.titleMessageError, getErrorModalActionTitle = _a.getErrorModalActionTitle, errorLogger = _a.errorLogger;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _b = (_d = store === null || store === void 0 ? void 0 : store.dependencies) !== null && _d !== void 0 ? _d : {}, setModalAction = _b.setModalAction, errorLoggerGlobal = _b.errorLoggerGlobal;
                _e.label = 1;
            case 1:
                _e.trys.push([1, 14, 23, 26]);
                if (!loadingStartAction) return [3 /*break*/, 3];
                return [4 /*yield*/, put(loadingStartAction())];
            case 2:
                _e.sent();
                _e.label = 3;
            case 3: return [4 /*yield*/, call(downloadFileRequest, requestParams)];
            case 4:
                _c = _e.sent(), error = _c.error, errorText = _c.errorText, data = _c.data, additionalErrors = _c.additionalErrors;
                if (error) {
                    // serialize data to be catched to the "catch" block and to be parsed
                    throw new Error(JSON.stringify({
                        errorText: errorText,
                        additionalErrors: additionalErrors,
                    }));
                }
                formattedData_1 = responseDataFormatter
                    ? responseDataFormatter(data)
                    : data;
                return [4 /*yield*/, downloadFile({
                        fileType: fileType,
                        file: formattedData_1.file,
                        contentType: formattedData_1.contentType,
                        name: formattedData_1.name,
                    })];
            case 5:
                _e.sent();
                if (!formSuccessAction) return [3 /*break*/, 7];
                return [4 /*yield*/, put(formSuccessAction(formattedData_1))];
            case 6:
                _e.sent();
                return [3 /*break*/, 9];
            case 7:
                if (!(formSuccessActionsArray && formSuccessActionsArray.length)) return [3 /*break*/, 9];
                return [4 /*yield*/, all(formSuccessActionsArray.map(function (successAction) {
                        return put(successAction(formattedData_1));
                    }))];
            case 8:
                _e.sent();
                _e.label = 9;
            case 9:
                if (!callBackOnSuccess) return [3 /*break*/, 11];
                return [4 /*yield*/, callBackOnSuccess({ dispatch: dispatch, responseData: formattedData_1 })];
            case 10:
                _e.sent();
                _e.label = 11;
            case 11:
                if (!(showNotificationSuccess &&
                    notificationSuccessMessage &&
                    setModalAction)) return [3 /*break*/, 13];
                return [4 /*yield*/, put(setModalAction({
                        status: 'success',
                        title: notificationSuccessMessage,
                    }))];
            case 12:
                _e.sent();
                _e.label = 13;
            case 13: return [3 /*break*/, 26];
            case 14:
                error_1 = _e.sent();
                console.error('downloadFilesManagerWorkerSaga gets an error', error_1);
                errorData_1 = getParsedError({
                    sagaName: 'downloadFilesManagerWorkerSaga',
                    error: error_1,
                });
                if (!(showNotificationError && setModalAction)) return [3 /*break*/, 16];
                customModalTitle = titleMessageError || (getErrorModalActionTitle === null || getErrorModalActionTitle === void 0 ? void 0 : getErrorModalActionTitle(errorData_1.errorText));
                params = customModalTitle
                    ? {
                        status: 'error',
                        title: customModalTitle,
                        text: errorData_1.errorText,
                    }
                    : {
                        status: 'error',
                        text: errorData_1.errorText,
                    };
                return [4 /*yield*/, put(setModalAction(params))];
            case 15:
                _e.sent();
                _e.label = 16;
            case 16:
                if (!setErrorAction) return [3 /*break*/, 18];
                return [4 /*yield*/, put(setErrorAction(errorData_1.errorText))];
            case 17:
                _e.sent();
                return [3 /*break*/, 20];
            case 18:
                if (!(setErrorActionsArray && setErrorActionsArray.length)) return [3 /*break*/, 20];
                return [4 /*yield*/, all(setErrorActionsArray.map(function (errorAction) {
                        return put(errorAction(errorData_1.errorText));
                    }))];
            case 19:
                _e.sent();
                _e.label = 20;
            case 20:
                if (!callBackOnError) return [3 /*break*/, 22];
                return [4 /*yield*/, callBackOnError({ dispatch: dispatch, errorData: errorData_1 })];
            case 21:
                _e.sent();
                _e.label = 22;
            case 22:
                if (errorLogger || errorLoggerGlobal) {
                    logger = errorLogger || errorLoggerGlobal;
                    logger({
                        error: error_1,
                        message: '[downloadFilesManagerWorkerSaga]: get an error',
                    });
                }
                return [3 /*break*/, 26];
            case 23:
                if (!loadingStopAction) return [3 /*break*/, 25];
                return [4 /*yield*/, put(loadingStopAction())];
            case 24:
                _e.sent();
                _e.label = 25;
            case 25: return [7 /*endfinally*/];
            case 26: return [2 /*return*/];
        }
    });
}
